import * as React from 'react'
import { Text, View } from 'react-native'
import styled from '@theme/styled-components'
import Theme from '@theme/Theme'

import FilePicker from '@components/filePicker/FilePicker'
import Animators from '@components/root/Animators'
import Icon from '@components/icon/Icons'

import useI18n from '@i18n/useI18n'

import { FormikHelpers, useFormik } from 'formik'

interface Values {
  map: FileUpload
}

const Map = ({ form, onForm }: AdminPlanFormProps) => {
  const init: Values = React.useMemo(() => ({ map: form.map }), [form.map])

  const i18n = useI18n()

  const onSubmit = (vals: Values, { setSubmitting }: FormikHelpers<Values>) => {
    onForm(vals).finally(() => setSubmitting(false))
  }

  const { values, setFieldValue, handleSubmit, dirty } = useFormik<Values>({
    enableReinitialize: true,
    initialValues: init,
    onSubmit,
  })

  React.useEffect(() => {
    if (dirty) {
      // sumbit on change
      handleSubmit()
    }
  }, [values])

  const onFiles = (files: FileUpload[]) => {
    if (files && files.length > 0) {
      setFieldValue('map', files[0])
    }
  }

  const renderPreview = (p: FileUpload) => {
    return (
      <Item>
        <Icon name="document" size={50} />
        <Name>{p.filename}</Name>
      </Item>
    )
  }

  return (
    <MainContainer>
      <Animators>
        <FilePicker onFileUploaded={onFiles} allowAllTypes>
          <AddContainer>
            <Icon name="add-circle" color={Theme.colors.primary} size={25} />
            <Add>{i18n.t('screens.admin.plans.form.map.add')}</Add>
          </AddContainer>
        </FilePicker>

        {!!values.map && renderPreview(values.map)}
      </Animators>
    </MainContainer>
  )
}

export default Map

const MainContainer = styled(View)`
  margin: 0 20px;
  padding-top: ${(props) => (props.theme.breakpoint === 'phone' ? 0 : 125)}px;
`

const AddContainer = styled(View)`
  height: 250px;
  padding: 65px;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border: 2px dashed ${(props) => props.theme.colors.primary};
  border-radius: 8px;
`

const Add = styled(Text)`
  ${(props) => props.theme.fonts.Body};
  margin-left: 15px;
`

const Item = styled(View)`
  align-items: center;
  align-self: flex-start;
  margin: 25px;
`

const Name = styled(Text)`
  ${(props) => props.theme.fonts.Headline};
  margin-top: 8px;
`
